// Bridge lets the existing global sync dialog await the notification module
// without copying its transactional intents into the legacy array queue.
let current = null;
export const setNotificationBridge = bridge => { current = bridge; return () => { if (current === bridge) current = null; }; };
export const notificationPending = async () => current ? current.pending() : [];
export const syncNotificationsManually = async () => {
  const bridge = current;
  if (!bridge) return { synced: 0, failed: 0, count: 0 };
  const before = await bridge.pending();
  let failure;
  try { await bridge.sync(); } catch (error) { failure = error; }
  const remaining = new Set((await bridge.pending()).map(op => op.id));
  const synced = before.filter(op => !remaining.has(op.id)).length;
  const summary = { synced, failed: before.length - synced, count: before.length };
  if (failure) { failure.notificationSummary = summary; throw failure; }
  return summary;
};
